<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatUpper('nome')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="CPF" prop="cpf" key="cpf">
              <el-input v-model="dados.cpf" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Telefone" prop="telefone" key="telefone">
              <el-input v-model="dados.telefone" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-monitor" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    edit: false,
    filtroInstituicao: { id: '', nome: '' },
    dados: {
      id: '',
      instituicao_id: '',
      nome: '',
      cpf: '',
      telefone: ''
    }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/monitor/getById/` + id, this.$store.getters.getHeaderAuth)
      this.dados = JSON.parse(JSON.stringify(res.data))
    },
    onSubmit () {
      document.getElementById("btn-monitor").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/monitor/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
          } else {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/monitor/store`, this.dados, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitMonitor')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    },
    formatUpper (field) {
      if (!this.dados[field]) return
      this.dados[field] = this.$removerAcentos(String(this.dados[field]).toUpperCase())
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        }
      }
    }
  }
}
</script>

